module.exports = __webpack_public_path__ + "img/logo-little.07ab3641.svg";